import React, { use, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';
// import { FaFacebookF, FaSlash } from "react-icons/fa";
// import { FaLinkedinIn } from "react-icons/fa";
// import { FaInstagram } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
import MyProfileImage from './default.webp';
import { LoginContext } from '../../../context/LoginContext';
import { MessageContext } from '../../../context/MessageContext';


const ProfilePage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [related, setRelated] = useState([]);
  const [age, setAge] = useState(21);
  const [ismypro, setisMyPro] = useState(false);


  const [myHobbies, setmyHobbies] = useState([]);
  const { userData, userId, isLoggedIn, isPremium } = useContext(LoginContext);
  const { setMessageUserData, setMessageName, setMessageUserId, setIsMessage } = useContext(MessageContext)
  const param = useParams();



  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking_for", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", param.id);
    payload.append("limit", 30);

    if (param.id === userId) setisMyPro(true);
    else setisMyPro(false);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/view_profile`, payload)
      .then(response => {
        setUsers(response.data.details);
        if (response.data.details.dob) {
          setAge(calculateAge(response.data.details.dob));
        }
        if (response.data.details.hobbies != null) {
          let newhobbies = response.data.details?.hobbies?.split(',');
          setmyHobbies(newhobbies);
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });




    if (!ismypro) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/desire_patner_match`, payload)
        .then(response => {
          setRelated(response.data.matched.filter(user => user.user_id != param.id));

        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    }

  }, [param.id]);

  // Function to calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Function to format height (assuming height is stored as "feet.inches" like "5.6")
  const formatHeight = (height) => {
    if (!height) return 'N/A';
    const parts = height.split('.');
    if (parts.length === 2) {
      return `${parts[0]}'${parts[1]}"`;
    }
    return height;
  };


  const handleMessage = () => {
    setMessageUserData(users);
    setMessageName(users.name);
    setMessageUserId(users.user_id);
    setIsMessage(true);
    navigate(`/chat/${param.id}`);
  }




  return (
    <>

      <section>
        <style>
          {`


.pg-pro-big-im .s1 img{
height:375px;
}
       .menu-pop-soci ul li link i {
            width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
         .member-info h5, .member-id{
            color: white !important;
            text-align: center;
    }
      .detail-label{
            color: white !important;
      }
      .detail-value{
            color: white !important;
      }
        .recently-joined-container {
          padding: 60px 20px;
          background: #fff;
        }
          .swiper-container {
          padding: 0px;
          position: relative;
          margin-bottom: 30px;
        }
        .member-card {
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        .member-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }
        .member-image {
          width: 100%;
          height: 300px;
          object-fit: cover;
          display: block;
        }
        .member-info {
          background: #E53D5C;
          color: white;
          padding: 15px;
        }
        .member-id-gender {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: center;
        }
        .gender-badge {
          background: white;
          color: #E53D5C;
          border-radius: 3px;
          padding: 2px 5px;
          font-weight: bold;
          margin-right: 8px;
        }
        .member-id {
          font-weight: bold;
          font-size: 14px;
        }
        .member-details {
          font-size: 13px;
        }
        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .detail-row:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .detail-label {
          font-weight: 500;
        }
        .detail-value {
          text-align: right;
        }.swiper-button-next, .swiper-button-prev {
          color: #E53D5C;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        .swiper-button-next:hover, .swiper-button-prev:hover {
          background: #E53D5C;
          color: white;
        }
        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .swiper-pagination-bullet {
          background: #ccc;
          opacity: 1;
          width: 12px;
          height: 12px;
        }
        .swiper-pagination-bullet-active {
          background: #E53D5C;
        }
          .menu-pop-soci ul li  i {
    width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
        @media (max-width: 768px) {
          .swiper-container {
            padding: 0 20px;
          }
          .swiper-button-next, .swiper-button-prev {
            display: none;
          }
        }
        @media (max-width: 480px) {
          .recently-joined-container {
            padding: 40px 15px;
          }
          .member-details {
            font-size: 12px;
          }`}
        </style>
        <div class="profi-ban mt-5">
          <div class="container">
            <div class="row justify-content-center">
              <div class="profile col-lg-4 col-md-12 col-xl-4">
                <div class="pg-pro-big-im">
                  <div class="s1">
                    <img src={(users.image1) ? process.env.REACT_APP_API_BASE_URL + users.image1 : MyProfileImage} loading="lazy" class="pro" alt="" />

                    {(!ismypro) &&
                      <span onClick={handleMessage} className="btn rounded-0 btn-lg text-white d-block py-3" style={{ fontSize: "18px", background: "#E53D5C" }}><b>Message</b> Now</span>}

                    {(ismypro) && <>
                      <Link to={`/profile-picture/${userId}`} className="btn rounded-0 btn-lg text-white d-block py-3" style={{ fontSize: "18px", background: "#E53D5C" }}>Add Photos</Link>
                    </>
                    }
                  </div>
                  {/* <div class="">
                                <a href="#!" class="cta fol cta-chat">Message Now</a>
                            </div> */}
                </div>
              </div>
              <div class="col-lg-8 col-md-12 col-xl-8">
                <div class="lhs">
                  <div class="pro-pg-intro">
                    <h1 className='mb-0' style={{ textTransform: "capitalize" }}>{(users.name) ?? "Hi Guest"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></h1>
                    <div class="pro-info-status mb-3">
                      <span class="stat-1 btn px-3 py-1 m-2" style={{ fontSize: "18px" }}><b>{users.visitor}</b> Real Time Views</span>

                      {(!ismypro) && (<span class="stat-2 btn px-3 py-1 m-2" style={{ fontSize: "18px" }}><b>Recently</b> online</span>)}
                      {(ismypro) && <>
                        <Link to={`/edit-profile/${userId}`} class="btn-danger btn px-3 py-1 m-2" style={{ fontSize: "18px" }}><b>Edit</b> Profile</Link>
                      </>
                      }

                      {/* <Link to={`/profile-picture/${userId}`} class="btn-info btn px-3 py-1 m-2" style={{ fontSize: "18px" }}>Update Profile Picture</Link> */}

                    </div>
                    <ul className='mb-3'>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>City: <strong>{users.curr_location ?? "India"}</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-age.png" loading="lazy" alt="" />
                          <span>Age: <strong>{age}</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>Height: <strong>{users.height} Ft</strong></span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <img src="images/icon/pro-city.png" loading="lazy" alt="" />
                          <span>Profession: <strong>{users.occupation}</strong></span>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="pr-bio-c pr-bio-abo">
                    <h3 style={{ color: "#E53D5C" }}>About</h3>
                    <p>{users.desc}</p>
                  </div>






                </div>
              </div>


              <div class="col-md-12 py-2">

                {users.image2 && <div class="pr-bio-c pr-bio-gal" id="gallery">
                  <h3 style={{ color: "#E53D5C" }}>Photo gallery</h3>
                  <div id="image-gallery">


                    {[2, 3, 4, 5, 6].map((index) => {
                      const imageKey = `image${index}`;
                      const imageUrl = users[imageKey];

                      return (
                        imageUrl && (
                          <div className="pro-gal-imag" key={index}>
                            <div className="img-wrapper position-relative">
                              <a href="#">
                                <img
                                  src={process.env.REACT_APP_API_BASE_URL + imageUrl}
                                  className="img-responsive rounded-0"
                                  alt=""
                                />
                              </a>

                            </div>
                          </div>
                        )
                      );
                    })}








                  </div>
                </div>}

              </div>

              <div class="col-md-12 py-2">

                <h3 className='text-center fw-bold'>Profile <span style={{ color: "#E53D5C" }}>information</span> </h3>
                <div class="pr-bio-c pr-bio-info">
                  <div className='row'>
                    <div className='col-md-4' >
                      <ul>
                        <li><b>Name:</b> {(users.name != "") ? (users.name) : "Not Filled"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></li>
                        <li><b>Date of birth:</b>{(users.dob != "") ? (users.dob) : ("Not Filled")}</li>
                        <li><b>Religion:</b> {(users.religion != "") ? (users.religion) : "Not Filled"}</li>
                        <li><b>Caste:</b> {(users.caste != "") ? (users.caste) : "Not Filled"}</li>
                        <li><b>Current Location:</b> {(users.curr_location != "") ? (users.curr_location) : "Not Filled"}</li>
                       
                      </ul>

                    </div>
                    <div className='col-md-4' >
                      <ul>

                        <li><b>Mother Tounge:</b> {(users.language != "") ? (users.language) : "Not Filled"}</li>
                        <li><b>Marital Status:</b> {(users.marital_status != "") ? (users.marital_status) : "Not Filled"}</li>


                        <li><b>Age:</b> {(age != "") ? (age + " Years") : ("Not Filled")}</li>
                        <li><b>Height:</b>{(users.height != "") ? (users.height + " Ft") : "Not Filled"}</li>
                        <li><b>Weight:</b>{(users.weight != "") ? (users.weight + " Kg") : "Not Filled"}</li>
                      </ul>

                    </div>
                    <div className='col-md-4' >
                      <ul>
                        <li><b>Body Type:</b>{(users.bdy_type != "") ? (users.bdy_type) : "Not Filled"}</li>
                        <li><b>Physical Status:</b>{(users.ps != "") ? (users.ps) : "Not Filled"}</li>

                        <li><b>Eating Habits:</b>{(users.eating != "") ? (users.eating) : "Not Filled"}</li>
                        <li><b>Drinking Habits:</b>{(users.drinking != "") ? (users.drinking) : "Not Filled"}</li>
                        <li><b>Smoking Habits:</b>{(users.smoking != "") ? (users.smoking) : "Not Filled"}</li>
                      </ul>

                    </div>
                  </div>
            {/* <ul>
                    <li><b>Name:</b> {(users.name != "") ? (users.name) : "Not Filled"} <span style={{ color: "#E53D5C" }}> (HS{users.user_id})</span></li>
                    <li><b>Date of birth:</b>{(users.dob != "") ? (users.dob) : ("Not Filled")}</li>
                    <li><b>Religion:</b> {(users.religion != "") ? (users.religion) : "Not Filled"}</li>
                    <li><b>Caste:</b> {(users.caste != "") ? (users.caste) : "Not Filled"}</li>
                    <li><b>Current Location:</b> {(users.curr_location != "") ? (users.curr_location) : "Not Filled"}</li>
                    <li><b>Mother Tounge:</b> {(users.language != "") ? (users.language) : "Not Filled"}</li>
                    <li><b>Marital Status:</b> {(users.marital_status != "") ? (users.marital_status) : "Not Filled"}</li>


                    <li><b>Age:</b> {(age != "") ? (age + " Years") : ("Not Filled")}</li>
                    <li><b>Height:</b>{(users.height != "") ? (users.height + " Ft") : "Not Filled"}</li>
                    <li><b>Weight:</b>{(users.weight != "") ? (users.weight + " Kg") : "Not Filled"}</li>

                    <li><b>Body Type:</b>{(users.bdy_type != "") ? (users.bdy_type) : "Not Filled"}</li>
                    <li><b>Physical Status:</b>{(users.ps != "") ? (users.ps) : "Not Filled"}</li>

                    <li><b>Eating Habits:</b>{(users.eating != "") ? (users.eating) : "Not Filled"}</li>
                    <li><b>Drinking Habits:</b>{(users.drinking != "") ? (users.drinking) : "Not Filled"}</li>
                    <li><b>Smoking Habits:</b>{(users.smoking != "") ? (users.smoking) : "Not Filled"}</li>
                  </ul> */}

                </div>
              </div>




              <div class="col-md-4">

                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Education <span style={{ color: "#E53D5C" }}>Career</span> </h3>
                  <ul>
                    <li><b>Highest Education:</b> {(users.highest_edu != "") ? (users.highest_edu) : ("Not Filled")}</li>
                    <li><b>Edu Qual:</b> {(users.ug_degree != "") ? (users.ug_degree) : ("Not Filled")}</li>
                    <li><b>Profession:</b> {(users.occupation != "") ? (users.occupation) : ("Not Filled")}</li>
                    <li><b>Position:</b> {(users.emp_in != "") ? (users.emp_in) : ("Not Filled")}</li>
                    <li><b>Annual Income:</b>{(users.income != "") ? (users.income) : ("Not Filled")}</li>
                    <li><b>Company:</b> {(users.org_name != '') ? (users.org_name) : ("Not Filled")}</li>
                  </ul>
                </div>

              </div>
              <div class="col-md-4">


                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Family <span style={{ color: "#E53D5C" }}>Details</span> </h3>
                  <ul>
                    <li><b>Family Type:</b> {users.family_type != "" ? users.family_type : "Not Filled"}</li>
                    <li><b>Native State:</b> {users.family_based != "" ? users.family_based : "Not Filled"}</li>
                    <li><b>Brother:</b> {(users.brother != "") ? (users.brother) : ("Not Filled")}</li>
                    <li><b>sister:</b> {(users.sister != "") ? (users.sister) : ("Not Filled")}</li>
                    <li><b>Gothra:</b> {(users.gothraname != "") ? (users.gothraname) : ("Not Filled")}</li>
                    <li><b>Maternal Gothra:</b> {(users.gothramaternalname != "") ? (users.gothramaternalname) : ("Not Filled")}</li>
                  </ul>
                </div>

              </div>
              <div class="col-md-4">


                <div class="pr-bio-c pr-bio-info">
                  <h3 className='text-center'>Family <span style={{ color: "#E53D5C" }}>Details</span> </h3>
                  <ul>
                    <li><b>Living with Parent:</b> {(users.living_wth_parents != "") ? (users.living_wth_parents) : ("Not Filled")}</li>
                    <li><b>Country:</b> {(users.country != "") ? (users.country) : ("Not Filled")}</li>
                    <li><b>State:</b> {(users.state != "") ? (users.state) : ("Not Filled")}</li>
                    <li><b>City:</b> {(users.city != "") ? (users.city) : ("Not Filled")}</li>
                    <li><b>Pincode:</b> {(users.pin != "") ? (users.pin) : ("Not Filled")}</li>
                  </ul>
                </div>

              </div>

              <div class="col-md-12">

                {users.hobbies && <div class="pr-bio-c pr-bio-hob">
                  <h3 style={{ color: "#E53D5C" }}>Hobbies</h3>
                  <ul>
                    {myHobbies.map(res => (
                      <li><span style={{ textTransform: "capitalize" }}>{res}</span></li>
                    ))}
                  </ul>
                </div>}

                {/* <div class="pr-bio-c menu-pop-soci pr-bio-soc">
                    <h3 style={{ color: "#E53D5C" }}>Social media</h3>
                    <ul>
                      <li><i> <FaFacebookF /></i></li>
                      <li><i><FaLinkedinIn /></i></li>
                      <li><i><FaInstagram /></i></li>
                      <li><i><FaTwitter /></i></li>
                    </ul>
                  </div> */}
              </div>


              {(!ismypro) &&
                <div class="col-md-12" >
                  <div class="rhs">

                    <div class="slid-inn pr-bio-c wedd-rel-pro">
                      <h3 className='fs-3'>Related <span style={{ color: "#E53D5C" }}>profiles</span> </h3>
                      <div className="swiper-container">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          spaceBetween={10}
                          slidesPerView={1}
                          navigation
                          // pagination={{ clickable: true, dynamicBullets: true }}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false
                          }}
                          loop={true}
                          loopedSlides={users.length}
                          breakpoints={{
                            640: {
                              slidesPerView: 1,
                              spaceBetween: 0
                            },
                            768: {
                              slidesPerView: 2.5,
                              spaceBetween: 15
                            },
                            1024: {
                              slidesPerView: 3.5,
                              spaceBetween: 20
                            }
                          }}
                        >

                          {/* onClick={() => navigate(`/profile/${member.user_id}`)} */}

                          {related.slice(0, 30).map((member, index) => (
                            <SwiperSlide key={index}>
                              <Link style={{ color: "white" }}   to={isPremium?`/view-profile/${member.user_id}`:`/upgrade/${userId}`} >
                              <div className="member-card"
                                style={{ cursor: "pointer" }}>
                                <img
                                  src={`${process.env.REACT_APP_API_BASE_URL}${member.image1}`}
                                  alt={member.name}
                                  onError={(e) => {
                                    e.target.src = "./default.webp";
                                  }}
                                  className="member-image img-fluid"
                                />

                                <div className="member-info">
                                  <h5>{member.name}</h5>
                                  <div className="member-id-gender">
                                    <span className="member-id">
                                      {member.gender === 'male' ? 'M' : member.gender === 'female' ? 'F' : ''}
                                    </span>
                                    <span className="member-id">HS{member.user_id}</span>
                                  </div>

                                  <div className="member-details">
                                    <div className="detail-row">
                                      <span className="detail-label">Age:</span>
                                      <span className="detail-value">{calculateAge(member.dob)} Yrs</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Height:</span>
                                      <span className="detail-value">{formatHeight(member.height)}</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Gender:</span>
                                      <span className="detail-value">
                                        {member.gender === 'male' ? 'Male' : member.gender === 'female' ? 'Female' : 'N/A'}
                                      </span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Caste:</span>
                                      <span className="detail-value">{member.caste || 'N/A'}</span>
                                    </div>
                                    <div className="detail-row">
                                      <span className="detail-label">Location:</span>
                                      <span className="detail-value">{member.curr_location || member.country || 'India'}</span>
                                    </div>
                                  </div>
                                </div>
                              </div></Link>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    </div>

                  </div>
                </div>}


            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfilePage;
